<template>
    <div>
        <v-tooltip v-if="error" right color="red">
            <template v-slot:activator="{ on }">
                <v-chip color="red" dark small v-on="on">{{ value }}</v-chip>
            </template>
            <span style="white-space: pre-line">{{ error }}</span>
        </v-tooltip>
        <v-tooltip v-else-if="warning" right color="warning">
            <template v-slot:activator="{ on }">
                <v-chip color="orange" dark small v-on="on">{{ value }}</v-chip>
            </template>
            <span style="white-space: pre-line">{{ warning }}</span>
        </v-tooltip>
        <span v-else>{{ value }}</span>
    </div>
</template>

<script>
export default {
    name: "CSVItem",
    props: {
        value: {
            required: true
        },
        error: {
            type: String
        },
        warning: {
            type: String,
            default: ''
        }
    }
}
</script>